var map = {
	"./1.png": 52,
	"./2.png": 4543,
	"./3.png": 5526,
	"./4.png": 4921,
	"./5.png": 8672,
	"./6.png": 9963,
	"./7.png": 8834,
	"./8.png": 3365,
	"./9.png": 476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7962;